<template>
    <div>
        <div class="rcclQN" v-if="ship">
            <div class="royalBannerTitle">{{ship.title}}</div>
            <div class="royalBannerTxt">{{ship.subTitle}}</div>
            <section class="homeBanner mainSite clearfix" role="home-topBanner">
                <div class="carousel slide" id="topBanner" data-ride="carousel" data-pause="false">
                    <!-- Indicators -->
                    <ol class="carousel-indicators">
                        <li :class="{ active: i==0}" v-for="(banner, i) in banners" :key="('banner_dot_'+i)"
                            data-target="#topBanner" :data-slide-to="i">
                        </li>
                    </ol>

                    <div class="carousel-inner" role="listbox">
                        <div class="section--bg"></div>
                        <div class="item" :class="{ active: i==0}" v-for="(banner, i) in banners" :key="('banner_'+i)" >
                            <!--<a class="hold_link" onclick="" href="#"> </a>-->
                            <img :alt="ship.title" :src="banner">
                            <div class="banner_activity">
                            </div>
                        </div>

                        <div class="banner_activity" v-if="ship.hasVr&&ship.vrUrl">
                            <div class="banner_VRbtn" >
                                <a :href="ship.vrUrl" target="_blank" class="" style="">
                                    <img src="https://resource.rcclchina.com.cn/rcclQN/image/banner_VRbtn.png"
                                    @mouseenter="isShowVrQrCode=true" @mouseleave="isShowVrQrCode=false"/>
                                </a>
                            </div>
                            <div class="banner_VRTxt" v-show="isShowVrQrCode">
                                <div class="bannerVR_content">
                                    <img src="https://resource.rcclchina.com.cn/QN%E8%88%B9%E9%98%9F/VR%20%E4%BA%8C%E7%BB%B4%E7%A0%81.jpg">
                                    <div class="vrtext">手机扫一扫，体验更方便</div>
                                </div>
                            </div>
                        </div>
                        <div class="banner_activity" v-else>
                            <div class="banner_VRbtn">
<!--                              <router-link :to="`/Rccl.Cruise/CruiseSearch/Search?ShipCodes=${ship.shipCode}`" target="_blank" class="cruiseBtn" style="">查看全部航线</router-link>-->
<!--                                <a href="https://www.rclrow.com/Cruise/Search?offset=0&departureCodes=SIN" target="_blank" class="cruiseBtn" style="">查看全部航线</a>-->
                              <router-link :to="`/Rccl.Cruise/CruiseSearch/Search?offset=0&departureCodes=SIN`" target="_blank" class="cruiseBtn" style="">查看全部航线</router-link>
                            </div>
                        </div>
                    </div>
                    <!-- /.carousel -->
                </div>
            </section>
        </div>
        <div class="rcclQN">
            <div class="rcclQN__shipIntro">
                <div class="shipIntro__txtCon">
                    <div class="shipIntro__txtCon_left">
                        <p class="txt--blueB">{{ship.contentTitle}}</p>
                        <p class="txt--GrayB">{{ship.contentSubTitle}}</p>
                        <p class="txt--GrayS">
                            {{ship.content}}
                        </p>
                    </div>
                    <div class="shipIntro__txtCon_right">
                        <div class="shipIntro__txtCon_passengerNumber">
                            <div class="passengerNumber__pic"><img
                                    src="https://resource.rcclchina.com.cn/rcclQN/image/passengerNumber_3.png"></div>
                            <div class="passengerNumber__number">
                                <p class="rcclQN__number" style="color: #333333; font-weight: 500;">{{ship.capacity}}</p>
                                <p style="color: #333333; font-weight: 500;">载客人数</p>
                            </div>
                        </div>
                        <div class="shipIntro__txtCon_shipWeight">
                            <div class="shipWeight__pic"><img
                                    src="https://resource.rcclchina.com.cn/rcclQN/image/shipWeight_3.png"></div>
                            <div class="shipWeight__number">
                                <p class="rcclQN__number" style="color: #333333; font-weight: 500;">{{ship.weight}}</p>
                                <p style="color: #333333; font-weight: 500;">吨位</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="shipIntro__vedioCon">
                    <div class="video">
                        <video controls=""
                            :src="ship.videoUrl"
                            :poster="ship.videoCover"
                            width="100%" height="100%" class="pvideo-content"></video>

                        <div class="close-button"></div>
                    </div>
                    <div class="close-button"></div>
                </div>
            </div>
            <div class="shipIntro__iconCon" style="height: 470px; margin-top: -220px;">
                <div class="shipIntro__iconBg" style="height: 424px;">
                    <img src="https://resource.rcclchina.com.cn/rcclQN/image/infoBg.jpg">
                </div>
                <div class="shipIntro__iconInfo ">
                    <div class="shipIntro__iconInfoContainer">
                        <div class="shipIntro__iconSpeed shipIntro--icon">
                            <img src="https://resource.rcclchina.com.cn/rcclQN/image/infoSpeed.png">
                            <p><span>{{ship.speed}}</span>节</p>
                            <p>航速</p>
                        </div>
                        <div class="shipIntro__iconLength shipIntro--icon">
                            <img src="https://resource.rcclchina.com.cn/rcclQN/image/infoLength.png">
                            <p><span>{{ship.shipLength}}</span>米</p>
                            <p>长度</p>
                        </div>
                        <div class="shipIntro__iconWidth shipIntro--icon">
                            <img src="https://resource.rcclchina.com.cn/rcclQN/image/infoWidth.png">
                            <p><span>{{ship.shipWidth}}</span>米</p>
                            <p>宽度</p>
                        </div>
                        <div class="shipIntro__iconMadeIn shipIntro--icon">
                            <img src="https://resource.rcclchina.com.cn/rcclQN/image/infoMadeIn.png">
                            <p style="font-size: 18px; height: 36px;">{{ship.shipExplain}}</p>
                            <p>船厂建造</p>
                        </div>
                        <div class="shipIntro__iconShip shipIntro--icon">
                            <img src="https://resource.rcclchina.com.cn/rcclQN/image/infoShip.png">
                            <p><span>{{ship.firstTime}}</span></p>
                            <p>{{ship.departPort}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ShipDetailBanner",
    props: {
        ship: {
            type: Object,
            default () {
                return {}
            }
        }
    },
    data () {
        return {
            isShowVrQrCode: false
        }
    },
    mounted () {

    },
    beforeDestroy () {

    },
    methods: {

    },
    computed: {
        banners () {
            return this.ship.bannerImages || []
        }
    }
}
</script>

<style lang="less" scoped>
.rcclQN {
    width: 100%;
    background: #f5f5f5;
    color: #fff;
    position: relative;
    z-index: 1;
    .royalBannerTitle {
        font-size: 32px;
        z-index: 2;
        position: absolute;
        top: 40%;
        width: 100%;
        text-align: center;
        font-weight: 500;
    }
    .royalBannerTxt {
        font-size: 16px;
        z-index: 2;
        position: absolute;
        top: 50%;
        width: 100%;
        text-align: center;
    }
    .carousel-indicators {
        position: absolute;
        bottom: 40%;
        right: 92px;
        left: auto;
        z-index: 15;
        width: 30px;
        padding: 25px 8px;
        /* margin-left: -5%; */
        text-align: center;
        list-style: none;
        background-color: rgba(0, 0, 0, 0.5);
        border-radius: 15px;
        margin-right: 0;
        li {
            width: 10px;
            height: 10px;
            margin: 5px 1px;
            text-indent: -999px;
            cursor: pointer;
            background-color: #fff;
            border-radius: 10px;
        }
        .active {
            width: 12px;
            height: 20px;
            margin: 0;
            background-color: #fbba31;
        }
    }

     .section--bg {
        position: absolute;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.3);
        z-index: 1;
    }
    .banner_activity {
        width: 100%;
        position: absolute;
        bottom: 10.87%;
        left: 0;
        z-index: 10;
        .banner_VRbtn {
            width: 100%;
            text-align: center;
            img {
                width: 10.89%;
            }
            .cruiseBtn {
                position: relative;
                width: 143px;
                height: 37px;
                background: #FBBB02;
                display: block;
                margin: auto;
                color: black;
                font-size: 15px;
                line-height: 37px;
                font-weight: 500;
                &:hover{
                    text-decoration: none;
                }
            }
        }
        .banner_VRTxt {
            position: relative;
            text-align: center;
            bottom: 264px;
            .bannerVR_content {
                width: 200px;
                margin: 15px auto 0;
                padding: 10px 0;
                background: #fff;
                img {
                    width: 150px;
                }
                .vrtext {
                    font-size: 14px;
                    line-height: normal;
                    color: #000;
                }
            }
        }
    }

    .rcclQN__shipIntro {
        width: 100%;
        .shipIntro__txtCon {
            width: 59.375%;
            min-width: 1024px;
            margin: 0 auto;
            padding: 28px 8.25% 24px 0px;
            overflow: hidden;
            .shipIntro__txtCon_left {
                width: 78%;
                float: left;
            }
            .shipIntro__txtCon_right {
                float: right;
                padding-top: 14px;
                .shipIntro__txtCon_passengerNumber {
                    overflow: hidden;
                    .passengerNumber__pic {
                        width: 79px;
                        height: 55px;
                        display: inline-block;
                        vertical-align: bottom;
                    }
                    .passengerNumber__number {
                        display: inline-block;
                        text-align: center;
                        p {
                            color: #fff;
                            font-size: 14px;
                            margin-bottom: 0px;
                        }
                    }

                }
                .shipIntro__txtCon_shipWeight {
                    overflow: hidden;
                    margin-top: 38px;
                    .shipWeight__pic {
                        width: 72px;
                        height: 57px;
                        display: inline-block;
                        vertical-align: bottom;
                    }
                    .shipWeight__number {
                        display: inline-block;
                        text-align: center;
                        p {
                            color: #fff;
                            font-size: 14px;
                            margin-bottom: 0px;
                        }
                    }
                }
            }
        }

        .shipIntro__vedioCon {
            width: 59.375%;
            min-width: 1024px;
            margin: 0 auto;
            background: #fff;
            padding: 40px;
            border: 2px solid #eaeaea;
            border-radius: 4px;
            position: relative;
            z-index: 111;
        }
    }

    .shipIntro__iconCon {
        width: 100%;
        height: 540px;
        margin-top: -270px;
        position: relative;
        .shipIntro__iconBg {
            width: 100%;
            height: 534px;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .shipIntro__iconInfo {
            width: 100%;
            position: absolute;
            bottom: 70px;
            text-align: center;
            overflow: hidden;
            .shipIntro__iconInfoContainer {
                width: 59.375%;
                min-width: 1024px;
                margin: 0 auto;
                .shipIntro--icon {
                    width: 19%;
                    display: inline-block;
                    img {
                        width: 39px;
                        height: 37px;
                        margin-bottom: 26px;
                    }
                    p {
                        color: #fff;
                        font-size: 14px;
                    }
                    span {
                        color: #fff;
                        font-family: arial;
                        font-size: 24px;
                    }
                }
            }
        }
    }
}

.rccl_bga{
	background: #000;
	opacity: 0.8;
}
.rcclQN__number{
	font-size: 24px !important;
}
.txt--blueB{
	font-size: 36px;
	font-weight: bold;
	color: #000f57;
}
.txt--GrayB{
	font-size: 24px;
	font-weight: bold;
	color: #666666;
}
.txt--GrayS{
	font-size: 14px;
	color: #666666;
}
</style>


